import { useLanguage } from "@/context/LanguageContext";
import { listingPostLabels } from "@/i18n";

export const ModalInfoVehicleImages = () => {
  const { language } = useLanguage();
  const guide = (listingPostLabels(language).images?.guide ?? {}) as Record<
    string,
    string | string[] | Record<string, string>
  >;

  const title =
    guide.title ?? "Guide: Så testar och fotar du din bil inför auktion";
  const intro = guide.intro ?? "";
  const benefit1 = guide.benefit1 ?? "";
  const benefit2 = guide.benefit2 ?? "";
  const minPicsTitle = guide.minPicsTitle ?? "";
  const minPics = (guide.minPics ?? {}) as Record<string, string>;
  const totalPics = guide.totalPics ?? "";
  const morePics = guide.morePics ?? "";
  const photoTipsTitle = guide.photoTipsTitle ?? "";
  const photoTips = (guide.photoTips ?? []) as string[];
  const equipmentTitle = guide.equipmentTitle ?? "";
  const equipmentIntro = guide.equipmentIntro ?? "";
  const equipmentItems = (guide.equipmentItems ?? []) as string[];

  return (
    <div className="text-sm space-y-4">
      <h3 className="font-semibold text-lg text-blue-500">{title}</h3>
      <p>{intro}</p>
      <div className="bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg space-y-1">
        <p className="text-blue-700 dark:text-blue-300">👉 {benefit1}</p>
        <p className="text-blue-700 dark:text-blue-300">👉 {benefit2}</p>
      </div>

      <div>
        <h4 className="font-semibold mb-2">{minPicsTitle}</h4>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>
            <b>{minPics.exterior}</b>
          </li>
          <li>
            <b>{minPics.wheels}</b>
          </li>
          <li>
            <b>{minPics.interior}</b>
          </li>
          <li>
            <b>{minPics.equipment}</b>
          </li>
          <li>
            <b>{minPics.damage}</b>
          </li>
          <li>
            <b>{minPics.service}</b>
          </li>
        </ul>
        <div className="mt-2 bg-green-50 dark:bg-green-900/20 p-2 rounded">
          <p className="text-green-700 dark:text-green-300">👉 {totalPics}</p>
          <p className="text-green-700 dark:text-green-300">👉 {morePics}</p>
        </div>
      </div>

      <div>
        <h4 className="font-semibold mb-2">{photoTipsTitle}</h4>
        <ul className="list-disc list-inside space-y-1 ml-2">
          {photoTips.map((tip, i) => (
            <li key={i}>{tip}</li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="font-semibold mb-2">⭐ {equipmentTitle}</h4>
        <p className="mb-2">{equipmentIntro}</p>
        <ul className="list-disc list-inside space-y-1 ml-2">
          {equipmentItems.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};
